import { select } from 'redux-saga/effects';
import { eachYearOfInterval, addYears, startOfYear } from 'date-fns';

const getSelectedDateRange = ({ selectedDateRange }) => selectedDateRange;

export function* getTimelineQuery({ timeline }) {
  const selectedDateRange = yield select(getSelectedDateRange);
  if (timeline) {
    // Use selected date if available
    if (selectedDateRange.start && selectedDateRange.end) {
      return {
        [timeline.dateColumn || 'date']: [
          `before:${selectedDateRange.end.toDateString()}`,
          `after:${selectedDateRange.start.toDateString()}`,
        ],
      };
    }
    // Otherwise default to the timeline's range
    const start = new Date(timeline.start);
    const end = startOfYear(addYears(new Date(timeline.end), 1));
    const quarterDates = eachYearOfInterval({ start, end });

    return {
      [timeline.dateColumn || 'date']: [
        `before:${quarterDates[quarterDates.length - 1].toDateString()}`,
        `after:${quarterDates[quarterDates.length - 2].toDateString()}`,
      ],
    };
  }

  return {};
}
